export interface Esercizio {
  id: number | null;
  type: string;
  preview_image: File | string | null;
  vocal_name: string;
  full_name: string;
  vocal_description: string;
  full_description: string;
  position: string;
  execution: string;
  purpose: string;
  gravity_management_complexity: number;
  motor_coordination_complexity: number;
  cardiorespiratory_complexity: number;
  muscle_groups: string;
  equipment: number[];
  posture: string;
  complex_function: number | null;
  mode: string;
  recommended_for: number[]
  contraindicated_for: number[] 
  reminders: number[];
  status: string;
  video: File | string | null;
  animation: File | string | null;
  body_tracking: string | null;
  category: string ;
  evaluation_params_cgg: { key: string; value: number  }[];
  evaluation_params_ccm: { key: string; value: number  }[];
  evaluation_params_icr: { key: string; value: number  }[];
  esercizio_correlato: number | null;
  filename_image: string | null;
  filename_video: string | null;
  filename_animation: string | null;
  filename_json: string | null;
}

export const esercizioVuoto =
{
  id: null,
  type: "Exercise",
  preview_image: null,
  vocal_name: "",
  full_name: "",
  vocal_description: "",
  full_description: "",
  position: "",
  execution: "Aerobic",
  purpose: "Rebalancing",
  gravity_management_complexity: 0,
  motor_coordination_complexity: 0,
  cardiorespiratory_complexity: 0,
  muscle_groups: "FullBody",
  equipment: [],
  posture: "GAA_APA",
  complex_function: null,
  mode: "Isotonic",
  recommended_for: [],
  contraindicated_for: [],
  reminders: [],
  status: "Draft",
  video: null,
  animation: null,
  body_tracking: null,
  category: "",
  evaluation_params_cgg: [],
  evaluation_params_ccm: [],
  evaluation_params_icr: [],
  esercizio_correlato: null,
  filename_image: null,
  filename_video: null,
  filename_animation: null,
  filename_json: null,
}

export type Align = 'right' | 'left' | 'center';

export const tipologia = [
  { value: "Exercise", name: "Esercizio" },
  { value: "SelfTreatment", name: "Auto-trattamento" },
  { value: "EducationalSpot", name: "Sport educativo" },
]


export const finalita = [
  { value: "Rebalancing", name: "Riequilibrio" },
  { value: "Control", name: "Controllo" },
  { value: "PreparatoryToFunction", name: "Propedeutico alla funzione" },
]

export const esecuzioni = [
  { value: "Aerobic", name: "Aerobica" },
  { value: "Anaerobic", name: "Anaerobica" },
]

export const modalita = [
  { value: "Isotonic", name: "Isotonica" },
  { value: "Isometric", name: "Isometrica" },
  { value: "Isokinetic", name: "Isocinetica" },
]

export const categorie = [
  { value: 'Alimentation', name: 'Alimentazione' },
  { value: 'Emotionality', name: 'Emotività' },
  { value: 'Energy', name:'Energia'},
  { value: 'Movement_for_the_day', name:'Movimento per il giorno'},
  { value: 'Movement_for_the_night', name:'Movimento per il giorno'},
]

export type EsercizioCorrelatoObject = {
    id: number;
    position: string;
    full_name: string;
};

export type ParametroValutativo = {
    key: string;
    label: string;
};

interface select {
    id: number;
    name: string;
}

export const parametri_valutativi_cgg: ParametroValutativo[] = [
  {key: 'h1',label: 'Raggiungimento del punto massimo H1'},
  {key: 'h2',label: 'Raggiungimento del punto massimo H2'},
  {key: 'k',label: 'Valore costante di K'},
  {key: 'diff_vert_h2_vert_h1',label: 'Coincidenza H1 e H2'},
  {key: 'delta',label: 'Delta relativo'},
  {key: 'ritornoinposizioneiniziale',label: 'Ritorno in posizione iniziale'},
  {key: 'larghezzaspalle',label: 'Costante Larghezza spalle'},
  {key: 'piediapapera',label: "Piedi a papera"},
  {key: 'dance1',label: '1° posizione di danza'},
  {key: 'dance2',label: '2° posizione di danza'},
  {key: 'dance3',label: '3° posizione di danza'},
  {key: 'dance4',label: '4° posizione di danza'},
  {key: 'dance5',label: '5° posizione di danza'},
  {key: 'talloniuniti',label: 'Talloni uniti'},
  {key: 'tallonidivaricati',label: 'Talloni divaricati'},
  {key: 'unpiedeavantilaltro',label: "Un piede avanti all'altro a 45° per lato"},
  {key: 'monopodalicofissosuavampiede',label: 'Monopodalico Fisso su Avanpiede'},
  {key: 'monopodalicoalternatoveloce',label: 'Monopodalico alternato veloce'},
  {key: 'monopodalicoalternatolento',label: 'Monopodalico alternato lento'},
  {key: 'piedidivaricatilarghezzaspalle',label: 'Piedi larghezza spalle'},
  {key: 'piedidivaricatimenodellalarghezzaspalle',label: 'Piedi meno della larghezza spalle'},
  {key: 'piedidivaricatibenpiudellalarghezzaspalle',label: 'Piedi ben oltre la larghezza spalle'},
  // {key: 'piedidivaricatipiuomenolarghezzaspalleinappoggiosolocontuttoilpiede',label: 'Appoggio con tutto il piede'},
  {key: 'monopodalicofisso',label: 'Monopodalico fisso'},
  {key: 'piediunoavantilaltrodistanti',label: 'Piedi in linea, distanti'},
  // {key: 'raggiungimentomassimoh4assez',label: 'Raggiungimento del massimo di H4 su asse Z'},
  {key: 'sedutoconappoggioposteriore',label: 'Seduto con appoggio posteriore'},
  {key: 'raggiungimentomaxhH4asseZmassimoh1massimoh2costantek',label: 'Massimo di H1 e spalle rispetto H2 su asse Z'},
  {key: 'mantenutaposizionediposizionesupina',label: 'Supino'},
  {key: 'mantenutaposizionediposizioneprona',label: 'Prono'},
  // {key: 'mantenutaposizionedidecubitolateralesx',label: 'Decubito laterale sx'},
  // {key: 'mantenutaposizionedidecubitolateraledx',label: 'Decubito laterale dx'},
  {key: 'mantenutaposizionedidecubitolateraledx',label: 'Decubito laterale'},
  {key: 'troncoinclinatoorizzontale',label: 'DAA con tronco orizzontale'},
  {key: 'troncoeretto',label: 'DAA con tronco eretto'},
  {key: 'h2quantoscenderispettoalleginocchia',label: 'Delta oggettivo'},
  {key: 'aperturaanteroposterioreartiinferioriparilunghezzadellagamba',label: 'Apertura AP arti inferiori pari lunghezza della gamba'},
  {key: 'zdih2trateh1',label: 'z di H2 tra T e H1'},
  {key: 'massimodizdit',label: 'Massimo z di T'},
  {key: 'massimodiydit',label: 'Massimo y di T'},
  {key: 'zdih1allineataconzdit',label: 'z di H1 allineata con z di T'},
  {key: 'ancheggiare',label: 'Ancheggiare'},
  {key: 'rullaggiopiediavantiedietro',label: 'Rullaggio piedi avanti e dietro'},
  {key: 'allineamentoartiinferiori',label: 'Allineamento ginocchio-piede a terra'},
  // {key: 'alternanzaeserciziodestraesinistra',label: 'Alternanza esercizio destra e sinistra'},
  // {key: 'piedidistantipersaltelli',label: 'Piedi distanti per saltelli'},
  // {key: 'basculamentodelbacinomezzaluna',label: 'Basculamento del bacino (mezza luna)'},
  // {key: 'sincronismobacinoerullaggiopiedi',label: 'Sincronismo bacino e rullaggio piedi'},
  // {key: 'controllorespirazineaddominale',label: 'Controllo respirazine addominale'},
];

export const parametri_valutativi_ccm: ParametroValutativo[] = [
  {key: 'bracciaabdottea90',label: 'Braccia abdotte a 90°'},
  {key: 'massimaelevazioneconflessoestensioniavambraccialternataosincrona',label: 'Massima elevazione con flesso-estensioni avambracci'},
  {key: 'artisuperioriinmassimaelevazioneav',label: 'Arti superiori in massima elevazione a V'},
  {key: 'flessoestensioniartisuperioriorizzontali',label: 'Flesso-estensioni arti superiori orizzontali'},
  {key: 'rotazioniartisuperioriinmassimaelevazione',label: 'Rotazioni arti superiori in massima elevazione'},
  {key: 'allineamentobilancierepesiconbasediappoggio',label: 'Allineamento bilanciere/pesi con base di appoggio'},
  {key: 'coordinazionegenerale',label: 'Coordinazione generale'},
]

export const parametri_valutativi_icr: ParametroValutativo[] = [
  {key: 'numeroripetizioni',label: 'Numero ripetizioni'},
  {key: 'duratadellesercizio',label: 'Durata dell\'esercizio'},
  {key: 'valutazionedeltrend',label: 'Tendenza di K'},
]


export const assetti = [
  { value: "GAA_APA", name: "GAA-APA" },
  { value: 'DAA_APA', name: 'DAA-APA' },
  { value: 'AAS_TAI', name: 'AAS-TAI' },
  { value: 'AAS_API', name: 'AAS-API' },
  { value: 'APS_API', name: 'APS-API' },
  { value: 'GAA_SUP', name: 'GAA-SUP' },
  { value: 'GAA_PRO', name: 'GAA-PRO' },
  { value: 'GAA_DL_right', name: 'GAA-DL-dx' },
  { value: 'GAA_DL_left', name: 'GAA-DL-sx' }
]
  const center: Align = 'center'
  export const THead = [
    { id: "frequency", label: "n°vu", width: "50px" },
    { id: "position", label: "Posizione", width: "100px" },
    { id: "full_name", label: "Nome corto", width: "300px" },
    { id: "vocal_name", label: "Nome vocale", width: "150px" },
    { id: "full_description", label: "Descrizione", width: "150px" },
    { id: "vocal_description", label: "Descrizione vocale", width: "150px" },
    //{ id: "type", label: "Tipologia", width: "100px" },
    { id: "execution", label: "Esecuzione", width: "100px" },
    { id: "mode", label: "Modalità", width: "80px" },
    { id: "purpose", label: "Finalità", width: "170px" },
    { id: "muscle_groups", label: "Comparto", width: "130px" },
    { id: "posture", label: "Assetto", width: "100px" },
    { id: "complex_function", label: "Funzionalità Complessa", width: "170px" },
    { id: "equipment", label: "Attrezzi", width: "150px" },
    { id: "recommended_for", label: "Raccomandato Per", width: "150px" },
    { id: "contraindicated_for", label: "Controindicato Per", width: "150px" },
    { id: "gravity_management_complexity", label: "C.G.G", width: "50px" },
    { id: "motor_coordination_complexity", label: "C.C.M", width: "50px" },
    { id: "cardiorespiratory_complexity", label: "I.C.R", width: "50px" },
    { id: "evaluation_params_cgg", label: "Metriche C.G.G.", width: "150px" },
    { id: "evaluation_params_ccm", label: "Metriche C.C.M.", width: "150px" },
    { id: "evaluation_params_icr", label: "Metriche I.C.R.", width: "150px" },
    { id: "status", label: "Stato", width: "45px", align: center },
    { id: "preview_image", label: "Anteprima", width: "60px", align: center },
    { id: "video", label: "Video", width: "60px", align: center },
    { id: "three_d", label: "3D", width: "60px", align: center },
    { id: "json", label: "Json", width: "60px", align: center },
  ];


  export const tooltipColumnIds = [
    'full_description',
    'vocal_description',
    'vocal_name',
    'recommended_for',
    'contraindicated_for',
    'equipment',
    'preview_image',
    "evaluation_params_cgg",
    "evaluation_params_ccm",
    "evaluation_params_icr",
  ]



